var App = App || {};

App.ZagScrollAnimate = (function ($) {
    'use strict';

    function Init() {

        $(".page-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".page-masthead-title", type: "animate__fadeInUp", stagger: 0 },
                { selector: ".page-masthead-rich-text", type: "animate__fadeInUp", stagger: 0 },
                { selector: ".page-masthead-ctas > ul > li", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".page-masthead-home").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".page-masthead-home__ctas", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".cross-promo-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".cross-promo .cross-promo__image-image", type: "animate__zoomIn", stagger: 0 }
            ]
        });

        $(".component-instagram-embed").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".container", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".category-list").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".container", type: "animate__fadeInUp", stagger: 0 }
            ]
        });


        $(".block-columns .rich-text").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: "h2:first-child", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".contact-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: "h2", type: "animate__fadeInUp", stagger: 0 },
                { selector: ".contact-band__wrapper > div", type: "animate__fadeInUp", stagger: 100 }

            ],
            overflow: true
        });

        //$(".widget-carousel .widget-carousel-slides").ZagScrollAnimate({
        //    offset: 75,
        //    targets: [
        //        { selector: ".splide", type: "animate__fadeInRight", stagger: 0 }
        //    ],
        //    overflow: true
        //});

    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ZagScrollAnimate.Init();
});